// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import type React from 'react';

import { Avatar } from '@change/ds-core-ui/Avatar';
import { Text } from '@change/ds-core-ui/Text';

import type { SignerPillColors } from '../../shared/carouselColorSchemes';

/**
 * The `LabeledAvatar` `size="x-small" container="inline"` layout (@change/ds-core-ui 16.3.0), rebuilt from
 * `Avatar` and `Text` because `LabeledAvatar` cannot color its text. The avatar matches control: the photo,
 * or the DS default illustration without one, so only color differs between arms.
 */
export const ColoredSignerPill: React.FC<Props> = ({ name, metatext, photoUrl, colors }) => {
	return (
		<div
			className="flex w-fit flex-row items-center gap-2 rounded-full bg-(--signer-pill-fill) py-1 pr-3 pl-1.5 dark:bg-(--signer-pill-fill-dark)"
			style={colors.style}
			data-testid="colored-signer-pill"
		>
			<Avatar size="x-small" alt={name} src={photoUrl} />
			<div>
				<div className="flex items-center gap-1">
					<Text
						size="x-small"
						variant="body"
						fontWeight="bold"
						className="text-(--signer-pill-text) dark:text-(--signer-pill-text-dark)"
					>
						{name}
					</Text>
					<Text size="x-small" variant="body" className="text-(--signer-pill-text) dark:text-(--signer-pill-text-dark)">
						{metatext}
					</Text>
				</div>
			</div>
		</div>
	);
};

type Props = Readonly<{
	name: string;
	metatext: string;
	photoUrl?: string;
	colors: SignerPillColors;
}>;
